/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import NutSeedButtersProduct from 'models/NutSeedButtersProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState, textureOptions, typeOptions } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const NutSeedButtersPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSelect, asterisk } = useFormUtils()
  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        Type,
        Size,
        Texture,
        OtherTexture,
      } = current
      setPackaging({
        category,
        subCategory,
        Type: {
          value: Type || '',
          label: null || Type.length > 0 ? Type : 'Nut or Seed Butter Type',
        },
        Size,
        Texture: {
          value: Texture || '',
          label: null || Texture.length > 0 ? Texture : 'Texture',
        },
        OtherTexture,
      })
    } else if (!updating) {
      setCurrent(NutSeedButtersProduct)
      setPackaging(packagingInitialState)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.Texture === 'Other') {
        methods.setValue('OtherTexture', current.OtherTexture)
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="Type"
            placeholder={'Select Nut or Seed Butter Type'}
            options={typeOptions}
            onChange={([selected]) => {
              setSelect(selected, 'Type')
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Type"
              message={'⚠ Please select a Type'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="Size"
            control={methods.control}
            rules={{
              required: '⚠ Please enter product size',
              maxLength: { value: 5, message: '⚠ Size exceeds 5 characters' },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <ErrorMessage
            errors={methods.errors}
            name="Size"
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Texture {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="Texture"
            placeholder={'Select Texture'}
            options={textureOptions}
            onChange={([selected]) => {
              setSelect(selected, 'Texture')
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Texture"
              message={'⚠ Please select a Texture'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        {current?.Texture === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Texture (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="OtherTexture"
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                required: '⚠ Other Texture is required',
                maxLength: {
                  value: 15,
                  message: '⚠ Other Texture exceeds 15 characters.',
                },
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="OtherTexture"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
      </Col>
    </Row>
  )
}

export default NutSeedButtersPackage
